<template>
  <div class="rc-image-runtime" :class="{'to-left':component.properties.sortType==='toLeft','hidden':component.properties.sortType==='hidden'}">
    <div v-if="component.properties.sortType!=='hidden'" :class="[component.properties.slideModel ? 'rc-image-label-slide' : 'rc-image-label-normal']" :title="component.name">{{component.name}}</div>
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
      <span class="fa fa-question-circle"></span>
    </el-tooltip>
    <div class="rc-image-show-slide" v-if="component.properties.slideModel">
      <el-carousel :autoplay="false" :arrow="showArrow" height="200px">
        <el-carousel-item v-for="item in imageList" :key="item.src">
          <img :src="hasImage? ossDownloadUrl + item.src : item.src"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="rc-image-show-pic" v-else>
      <template v-if="!hasImage">
        <span>暂无图片</span>
      </template>
      <template v-else-if="imageList.length > 1">
        <el-dropdown placement="bottom-start" :hide-on-click='false'>
        <span class="el-dropdown-link">
          附件 ( {{ imageList.length }} )<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
          <el-dropdown-menu ref="imageDropdownMenu" class="rc-image-dropdown" slot="dropdown">
            <el-dropdown-item v-for="item in imageList" :key="item.src">
              <a class="item" :title="item.name">{{ item.name }}</a>
              <div class="preivew" @click.stop="previewFile(item)"><i class="el-icon-view"></i>预览</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template v-else>
        <div class="rc-image-one-file">
          <span class="file-name" :title="imageList[0].name">{{ imageList[0].name }}</span>
          <div class="preivew" @click.stop="previewFile(imageList[0])"><i class="el-icon-view"></i>预览</div>
        </div>
      </template>
    </div>
    <PicturePreview ref="picturePreview" @closePreview="closePreview" :coverPicList="coverPicList" v-if="swiperFlag" :src="previewFileSrc"></PicturePreview>
  </div>
</template>

<script>
import { componentMixin } from './mixins'
import PicturePreview from './picture-preview-swiper'

export default {
  name: 'rc-image',
  props: {
    component: Object,
    value: {
      default: ''
    },
    labelParameter: Object,
    index: [Number, String]
  },
  components: {
    PicturePreview
  },
  mixins: [componentMixin],
  data () {
    let ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl') || ''
    return {
      ossDownloadUrl: ossDownloadUrl,
      previewFileSrc: '',
      swiperFlag: false
    }
  },
  computed: {
    // 是否有图片了
    hasImage () {
      if (this.component.properties.imageList.filter(item => item.src).length !== 0) {
        return true
      } else {
        return false
      }
    },
    // 图片列表
    imageList () {
      let imageList = this.component.properties.imageList.filter(item => item.src)
      if (imageList.length === 0) {
        return [{src: require('../../design/assets/rc-image-empty.png')}]
      } else {
        return imageList
      }
    },
    // 是否展示左右箭头
    showArrow () {
      if (this.imageList.length <= 1) {
        return 'never'
      } else {
        return 'always'
      }
    },
    coverPicList () {
      return this.component.properties.imageList.map(item => {
        return {
          url: item.src,
          name: item.name
        }
      })
    }
  },
  methods: {
    previewFile (img) {
      this.previewFileSrc = img.src
      this.$nextTick(() => {
        this.swiperFlag = true
      })
    },
    closePreview () {
      this.swiperFlag = false
    }
  }
}
</script>

<style lang="scss">
.rc-image-runtime {
  .component-explain-tooltip {
    color: #c0c2c1;
    cursor: pointer;
    &:hover {
      color: #3a8ee6;
    }
  }
  .rc-image-label-slide{
    line-height: 28px;
    display: inline-block;
  }
  .rc-image-label-slide{
    line-height: 28px;
  }
  .rc-image-label-normal{
    min-width: 100px;
    text-align: right;
    display: inline-block;
    line-height: 28px;
    padding-right: 12px;
    box-sizing: border-box;
  }
  .rc-image-show-slide{
    .el-carousel {
      .el-carousel__container{
        .el-carousel__item{
          text-align: center;
          img{
            max-width: 100%;
            max-height: 100%;
          }
        }

      }
      .el-carousel__indicators{
        .el-carousel__indicator{
          display: none;
        }
      }
    }
  }
  .rc-image-show-pic{
    display: inline-block;
    .rc-image-one-file{
      position: relative;
      cursor: pointer;
      &:hover{
        .preivew{
          display: block;
        }
      }
      .preivew{
        display: none;
        position: absolute;
        color: #fff;
        width: 80px;
        height: 30px;
        background: rgba(0, 0, 0, .72);
        border-radius: 4px;
        line-height: 30px;
        z-index: 9999;
        left: 70px;
        top: 18px;
        text-align: center;
      }
    }
    .el-dropdown{
      .el-dropdown-link{
        cursor: pointer;
      }
    }
  }
}
.rc-image-runtime.to-left,.rc-image-runtime.hidden {
  display: flex;
  align-items: center;
  .component-explain-tooltip {
    color: #c0c2c1;
    cursor: pointer;
    &:hover {
      color: #3a8ee6;
    }
  }
  .rc-image-label-slide{
    line-height: 28px;
    display: inline-block;
  }
  .rc-image-label-normal{
    min-width: 100px;
    text-align: right;
    display: inline-block;
    line-height: 28px;
    padding-right: 12px;
    box-sizing: border-box;
  }
  .rc-image-show-slide{
    width: 397px;
    .el-carousel {
      .el-carousel__container{
        .el-carousel__item{
          text-align: center;
          img{
            max-width: 100%;
            max-height: 100%;
          }
        }

      }
      .el-carousel__indicators{
        .el-carousel__indicator{
          display: none;
        }
      }
    }
  }
  .rc-image-show-pic{
    display: inline-block;
    .rc-image-one-file{
      position: relative;
      cursor: pointer;
      &:hover{
        .preivew{
          display: block;
        }
      }
      a.item{
        text-align: left;
      }
      .preivew{
        display: none;
        position: absolute;
        color: #fff;
        width: 80px;
        height: 30px;
        background: rgba(0, 0, 0, .72);
        border-radius: 4px;
        line-height: 30px;
        z-index: 9999;
        left: 70px;
        top: 18px;
        text-align: center;
      }
    }
    .el-dropdown{
      .el-dropdown-link{
        cursor: pointer;
      }
    }
  }
}
  .rc-image-dropdown{
    .el-dropdown-menu__item{
      position: relative;
      width: 220px;
      >a{
        width: 100%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &:hover{
        .preivew{
          display: block;
        }
      }
      a.item{
        text-align: left;
      }
    }
    .preivew{
      display: none;
      position: absolute;
      color: #fff;
      width: 80px;
      height: 30px;
      background: rgba(0, 0, 0, .72);
      border-radius: 4px;
      line-height: 30px;
      z-index: 9999;
      left: 70px;
      top: 18px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-image.vue